import Vue from "vue";
import Vuex from "vuex";

// Modules
import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import auth from "./auth";
import client from "./client";
import user from "./user";
import booking from "./booking";
import bookings from "./bookings";
import services from "./services";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    // Foravila Modules
    app,
    appConfig,
    verticalMenu,
    auth,
    client,
    user,
    booking,
    bookings,
    services
  },
  strict: process.env.DEV
});
